
import React from "react";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff, Trash } from "lucide-react";

interface ArticleActionsProps {
  isPublic: boolean;
  onToggle: () => void;
  onDelete: () => void;
}

export function ArticleActions({ isPublic, onToggle, onDelete }: ArticleActionsProps) {
  return (
    <div className="text-right space-x-2">
      <Button
        variant="outline"
        size="icon"
        onClick={onToggle}
        title={isPublic ? "Απόκρυψη" : "Δημοσίευση"}
      >
        {isPublic ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={onDelete}
        title="Διαγραφή"
      >
        <Trash className="h-4 w-4" />
      </Button>
    </div>
  );
}
